export default "__VITE_ASSET__Bv4nUU1V__"